import React, { FC } from 'react';
import {
  BreakpointConfig,
  createBreakpoints,
  Picture,
} from '../Picture/Picture';
import { useTranslation } from '@wix/wix-i18n-config';

interface TemplateImageProps {
  isLazyLoad?: boolean;
  imagePath?: string;
  alt?: string;
  className?: string;
  onLoad?: () => void;
  onLoadStart?: () => void;
}

const SOURCE_IMAGE_SIZE = { width: 1920, height: 2222 };
export const BREAKPOINTS_CONFIG: BreakpointConfig[] = [
  {
    maxScreenWidth: 375,
    imageWidth: 295,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 833,
    imageWidth: 751,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1366,
    imageWidth: 401,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1440,
    imageWidth: 438.5,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 1920,
    imageWidth: 425.33,
    densityList: [1, 2],
  },
  {
    maxScreenWidth: 2560,
    imageWidth: 638.66,
    densityList: [1, 2],
  },
];

export const TemplateImage: FC<TemplateImageProps> = ({
  imagePath,
  isLazyLoad,
  alt,
  className,
  onLoad,
  onLoadStart,
}) => {
  const breakpoints = createBreakpoints(BREAKPOINTS_CONFIG, SOURCE_IMAGE_SIZE);
  const { t } = useTranslation();

  return (
    <Picture
      isLazyLoad={isLazyLoad}
      imagePath={imagePath || ''}
      sourceImageSize={SOURCE_IMAGE_SIZE}
      breakpoints={breakpoints}
      alt={t('templates.img.altText', alt)}
      onLoad={onLoad}
      onLoadStart={onLoadStart}
      imageClassName={className}
    />
  );
};
